import { FeedbackProps, SurveyProps } from '../types';

export type GenerateXIDResponse = {
  data?: { updateAppReview?: { xid?: string } };
};

export const XROUTEHDR = {
  gke: 'PHARMACY-GKE',
  rke: 'PHARMACY-RKE',
  gkeAndRke: 'account-gke-rke'
};
export const X_ROUTE_HEADER = 'x-route';
export const RETAIL_PROFILE_ID_TYPE = 'RETAIL_PROFILE_ID_TYPE';

const isLocal = process.env.ENV === 'local';
const URlPREFIX = !isLocal ? '/app-store-review' : '';

export class CVSData {
  //generate survey xid
  static generateXID = async (feedback: FeedbackProps): Promise<GenerateXIDResponse> => {
    try {
      const url = URlPREFIX + '/api/generateXID';
      const payload = {
        feedback
      };
      const res = await fetch(url, {
        method: 'POST',
        body: JSON.stringify(payload),
        headers: {
          'Content-type': 'application/json',
          'Accept': 'application/json'
        }
      });
      return await res.json();
    } catch (err) {
      console.log(err);
      return err;
    }
  };

  //submit survey details
  static submitSurvey = async (survey: SurveyProps): Promise<any> => {
    try {
      const url = URlPREFIX + '/api/submitSurvey';
      const payload = {
        survey
      };
      const res = await fetch(url, {
        method: 'POST',
        body: JSON.stringify(payload),
        headers: {
          'Content-type': 'application/json',
          'Accept': 'application/json'
        }
      });
      return await res.json();
    } catch (err) {
      console.log(err);
      return err;
    }
  };
}
